import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
// import useAuth from 'hooks/useAuth';
import { useAuth } from '@clerk/clerk-react';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      navigate('/login', {
        state: {
          from: location.pathname,
        },
        replace: true,
      });
    }
  }, [isLoaded, isSignedIn, navigate, location]);

  return children;
}

AuthGuard.propTypes = { children: PropTypes.any };
